<template>
  <div>
    <vue-apex-charts v-if="isMounted" width="100%" type="line" :options="options" :series="series" height="350px"></vue-apex-charts>
  </div>
</template>

<script>
    import ApexCharts from 'apexcharts';
    import VueApexCharts from 'vue-apexcharts'
    export default {
        data: () => ({
          isMounted: false,
          options: {
            chart: {
              height: 350,
              type: 'line',
              zoom: {
                enabled: false
              }
            },
            colors: ['#42CCCC','#363847','#2e2d7f'],
            dataLabels: {
              enabled: true
            },
            stroke: {
              curve: 'straight',
              lineCap: 'round'
            },
            grid: {
              row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
              },
            }
          },
        }),
        // eslint-disable-next-line
        props: ['type','width','series','x_axis'],
        methods: {},
        mounted: function(){
          let parThis = this;
          parThis.isMounted = true;
          parThis.options.xaxis = parThis.x_axis;
        },
        components: {VueApexCharts}
    };
</script>

<style lang="scss" scoped>
</style>
